function convertNewtonToCelsius(num) {
  let eq =
    "Converting " +
    num +
    "° newton to celsius: \n" +
    num +
    " * 100 / 33 = ";
  let rep = (num * 100) / 33;
  return eq + rep.toFixed(2);
}

function convertNewtonToFahrenheit(num) {
  let eq =
    "Converting " +
    num +
    "° newton to fahrenheit: \n" +
    num +
    " * 60 / 11 + 32 = ";
  let rep = (num * 60) / 11 + 32;
  return eq + rep.toFixed(2);
}

function convertNewtonToKelvin(num) {
  let eq =
    "Converting " +
    num +
    "° newton to kelvin: \n" +
    num +
    " * 100 / 33 + 273.15 = ";
  let rep = (num * 100) / 33 + 273.15;
  return eq + rep.toFixed(3);
}

function convertNewtonToRankine(num) {
  let eq =
    "Converting " +
    num +
    "° newton to rankine: \n" +
    num +
    " * 60 / 11 + 491.67 = ";
  let rep = (num * 60) / 11 + 491.67;
  return eq + rep.toFixed(3);
}

function convertNewtonToDelisle(num) {
  let eq =
    "Converting " +
    num +
    "° newton to delisle: \n" +
    "(33 - " +
    num +
    ") * 50 / 11 = ";
  let rep = ((33 - num) * 50) / 11;
  return eq + rep.toFixed(2);
}

function convertNewtonToRéaumur(num) {
  let eq =
    "Converting " + num + "° newton to réaumur: \n" + num + " * 80 / 33 = ";
  let rep = (num * 80) / 33;
  return eq + rep.toFixed(2);
}

function convertNewtonToRømer(num) {
  let eq =
    "Converting " +
    num +
    "° newton to rømer: \n" +
    num +
    " * 35 / 22 + 7.5 = ";
  let rep = (num * 35) / 22 + 7.5;
  return eq + rep.toFixed(3);
}

export {
  convertNewtonToRømer,
  convertNewtonToRéaumur,
  convertNewtonToDelisle,
  convertNewtonToRankine,
  convertNewtonToKelvin,
  convertNewtonToFahrenheit,
  convertNewtonToCelsius
};
